import { api, webapp, lang, isCn } from 'config';
import Request from '../utils/request';

export const login = (data = {}, options = {}) => {
    const LOGIN = /\/login/;
    const LOCKED = /locked/;
    const PASSWORD_RESET = /passwordReset/;

    const configRequest = {
        uri: `${webapp}${lang !== 'en' ? `/${lang}` : ''}/login`,
        data,
        form: true,
        redirect: true,
        ...options,
    };
    return Request.post(configRequest).execute(true)
        .then(response => {
            let error = null;
            if (response.url && LOGIN.test(response.url)) {
                error = (isCn && response.url && LOCKED.test(response.url)) ? 'new-login.login-form.error.locked' : ((response.url && PASSWORD_RESET.test(response.url)) ? 'new-login.login-form.error.passwordReset' : 'new-login.login-form.error.incorrect');
            }
            return {
                logged: (response.url && response.url.indexOf('login') === -1),
                twoFA: (response.url && response.url.indexOf('2fa') !== -1),
                url: response.url || '',
                error,
            }
        });
};

export const register = (data = {}, options = {}) => {
    const configRequest = {
        uri: `${webapp}${lang !== 'en' ? `/${lang}` : ''}/register`,
        data,
        redirect: false,
        ...options,
    };
    return Request.post(configRequest).execute();
};

export const accessDarwinex = (data = {}, dataLegals, options = {}) => {
    const configRequest = {
        uri: `${api}/user/settings`,
        data,
        redirect: false,
        ...options,
    };
    return Request.patch(configRequest).execute();
};

export const forgotPassword = (data = {}, dataLegals, options = {}) => {
    const configRequest = {
        uri: `${api}/user/settings/password/recovery`,
        data,
        redirect: false,
        ...options,
    };
    return Request.post(configRequest).execute(true);
};

export const resetPassword = (data = {}, dataLegals, options = {}) => {
    const configRequest = {
        uri: `${api}/user/settings/password/reset`,
        data,
        redirect: false,
        ...options,
    };
    return Request.post(configRequest).execute();
};

export const getLegals = () => {
    const configRequest = {
        uri: `${api}/user/signed-legal-documents?page=1&per_page=50&onlyActive=true`,
        redirect: false,
    };
    return Request.get(configRequest).execute().then(response => response.data);
};

export const signLegals = (data = {}, options = {}) => {
    const configRequest = {
        uri: `${api}/user/signed-legal-documents`,
        data,
        redirect: false,
        ...options,
    };
    return Request.post(configRequest).execute(true);
};

export const logout = () => {
    const configRequest = {
        uri: `${webapp}/logout`,
        redirect: false,
    };
    return Request.get(configRequest).execute()
        .then(response => response);
};

export const usersBasicInfo = () => {
    const configRequest = {
        uri: `${api}/user/settings`,
        redirect: false,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const userMe = () => {
    const configRequest = {
        uri: `${webapp}/me`,
        redirect: false,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const updateBasicInfo = (data = {}) => {
    const configRequest = {
        uri: `${api}/user/settings`,
        data,
        redirect: false,
    };
    return Request.patch(configRequest).execute()
        .then(response => response.data);
};
